module.exports = __webpack_public_path__ + "img/no-courses.bbb08557.svg";